import { render, staticRenderFns } from "./card-sign.vue?vue&type=template&id=208c7bc4&scoped=true"
import script from "./card-sign.vue?vue&type=script&lang=js"
export * from "./card-sign.vue?vue&type=script&lang=js"
import style0 from "./card-sign.vue?vue&type=style&index=0&id=208c7bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208c7bc4",
  null
  
)

export default component.exports